// ./../common/SuccessButton.jsx
import React from "react";

const SuccessButton = () => {
  return (
    <div className="success-button">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path>
      </svg>
    </div>
  );
};

export default SuccessButton;
